import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { setError, removeError } from '../../../modules/errors/actions/creators'
import { setProfileModalPage } from '../../../modules/profile/actions/creators'
import { doGetAllAds } from '../../../controllers/BannerAds'

import ManageCardsPage from '../components/ManageCardsPage/ManageCardsPage'

const mapStateToProps = reduxState => {
  const { auth, profile, errors } = reduxState

  const { accessToken } = auth
  const { profileModalPage } = profile
  const { errorList } = errors

  return { errorList, accessToken, profileModalPage, doGetAllAds }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setProfileModalPage,
      setError,
      removeError,
    },
    dispatch,
  )

const ConnectedManageCardsPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageCardsPage)

export default ConnectedManageCardsPage
